/*
 * Module for the Correspondence Summary report criteria page
 */
rs.module("content/reports/criteria/correspondencesummarycriteria",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the page
        function initialize(jsSelectors) {

            var criteria = $.js(jsSelectors.criteria);

            var templateTypeSelect = criteria.js(jsSelectors.templateTypeSelect);
            var ownerTypeSelect = criteria.js(jsSelectors.ownerTypeSelect);
            var templateSelect = criteria.js(jsSelectors.templateSelect);
            var templateNameHidden = criteria.js(jsSelectors.templateNameHidden);

            // register changed events
            templateTypeSelect.change(templateTypeOrOwnerTypeChanged);
            ownerTypeSelect.change(templateTypeOrOwnerTypeChanged);
            templateSelect.change(templateChanged);

            // Get Select Helper for templateTypeSelect and ownerTypeSelect since we're manipulating it
            var templateTypeSelectHelper = selectHelper.getHelper(templateTypeSelect);
            var ownerTypeSelectHelper = selectHelper.getHelper(ownerTypeSelect); 
            var templateSelectHelper = selectHelper.getHelper(templateSelect);

            enableDisableFields();

            // On template changed
            function templateChanged() {

                enableDisableFields();

                // Set Hidden Field (Template Name) based on selected value
                templateNameHidden.val(templateSelect.find(":selected").text());
            }

            // On template type or owner type changed
            function templateTypeOrOwnerTypeChanged() {

                enableDisableFields();
            }

            function enableDisableFields() {

                var allTypes = templateTypeSelect.val() == "";
                var allOwners = ownerTypeSelect.val() == "";

                templateSelectHelper.setDisabled(!(allTypes && allOwners));

                var allTemplates = templateSelect.val() == "";

                templateTypeSelectHelper.setDisabled(!allTemplates);
                ownerTypeSelectHelper.setDisabled(!allTemplates);
            }

        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);